"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _animations = require("promo-animation/dist/animations");

var _promoClip = _interopRequireDefault(require("./promo-clip"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class PromoPhoto extends _promoClip.default {
  constructor(clip, cdn, imageQuality) {
    super();
    this.clip = clip;
    const {
      timeline,
      animation,
      photo,
      crop
    } = this.clip;
    const animObj = {
      animationType: 'lottiephoto',
      start: timeline.start,
      end: timeline.end,
      animation,
      photo,
      crop,
      cdn
    };
    const {
      aspectRatio
    } = crop;
    const {
      width,
      height
    } = (0, _utils.getRatioObjectBy)('ratio', aspectRatio);
    this.animation = this.createPhotoAnimation(animObj, {
      width,
      height
    }, imageQuality);
  }

  createPhotoAnimation(animationObj, rect, imageQuality = 1) {
    const {
      width,
      height
    } = rect;
    const el = document.createElement('div');
    document.body.appendChild(el);
    el.style.width = `${width * imageQuality}px`;
    el.style.height = `${height * imageQuality}px`;
    el.style.visibility = 'hidden';
    el.id = `g-${this.guid}`;
    const animation = (0, _animations.createAnimation)(animationObj);
    animation.render(el); // remove imageQuality from container

    el.style.width = `${width}px`;
    el.style.height = `${height}px`;
    this.isReady = new Promise(resolve => {
      animation.addEventListener('ready', () => {
        console.log(el);
        this.canvas = el.querySelector('canvas');
        document.body.removeChild(el);
        animation.goToAndPlay(0);
        resolve();
      });
    });
    return animation;
  } // phot offset is 0


  get offset() {
    return 0;
  }

  set currentTime(time) {
    this.animation.goToAndStop(time);
  }

  get currentTime() {
    return 0; // this.activeVideo.currentTime;
  }

  get drawObj() {
    return {
      el: this.canvas,
      x: 0,
      y: 0,
      w: this.canvas.width,
      h: this.canvas.height
    };
  }

}

exports.default = PromoPhoto;